// Simulador de tenant - detecta el tenant actual
export const getCurrentTenant = () => {
  // En desarrollo, simular diferentes tenants
  const hostname = window.location.hostname;
  
  // Para desarrollo local, usar query param o localStorage para simular
  const urlParams = new URLSearchParams(window.location.search);
  const tenantParam = urlParams.get('tenant');
  const storedTenant = localStorage.getItem('current_tenant');
  
  if (tenantParam) {
    localStorage.setItem('current_tenant', tenantParam);
    return tenantParam;
  }
  
  // PRIORIDAD 1: Si hay tenant guardado manualmente, usarlo (permite cambio entre empresas)
  if (storedTenant) {
    return storedTenant;
  }
  
  // PRIORIDAD 2: Detección automática por dominio (solo si no hay selección manual)
  if (hostname.includes('chirak.cl')) {
    const defaultTenant = 'chirakChile';
    localStorage.setItem('current_tenant', defaultTenant);
    return defaultTenant;
  } else if (hostname.includes('chirak.pe')) {
    const defaultTenant = 'chirakPeru';
    localStorage.setItem('current_tenant', defaultTenant);
    return defaultTenant;
  }
  
  // PRIORIDAD 3: Mapeo específico de dominios (para casos particulares)
  const domainMapping = {
    'localhost': 'chirakChile', // Default para desarrollo
    '127.0.0.1': 'chirakChile'
  };
  
  const defaultTenant = domainMapping[hostname] || 'chirakChile';
  localStorage.setItem('current_tenant', defaultTenant);
  return defaultTenant;
};

// Cambiar tenant (para simular cambio de empresa)
export const switchTenant = (tenantId) => {
  const oldTenant = localStorage.getItem('current_tenant');
  localStorage.setItem('current_tenant', tenantId);
  
  // Disparar evento personalizado para notificar cambio inmediato
  window.dispatchEvent(new CustomEvent('tenantChanged', { 
    detail: { oldTenant, newTenant: tenantId } 
  }));
  
  console.log('🔄 Tenant cambiado:', { from: oldTenant, to: tenantId });
  return tenantId;
};

// Obtener información del dominio actual
export const getDomainInfo = () => {
  const hostname = window.location.hostname;
  const tenant = getCurrentTenant();
  
  return {
    hostname,
    tenant,
    isProduction: !hostname.includes('localhost') && !hostname.includes('127.0.0.1'),
    isDevelopment: hostname.includes('localhost') || hostname.includes('127.0.0.1'),
    isChileEnvironment: hostname.includes('chirak.cl'),
    isPeruEnvironment: hostname.includes('chirak.pe')
  };
};

// Obtener URL base según el tenant
export const getBaseUrl = () => {
  const { hostname, tenant, isProduction } = getDomainInfo();
  
  if (isProduction) {
    return tenant === 'chirakChile' 
      ? 'https://tarifario.chirak.cl' 
      : 'https://tarifario.chirak.pe';
  }
  
  return `http://${hostname}:3000`;
};

// Obtener configuración del tenant actual
export const getCurrentTenantConfig = () => {
  const { tenants } = require('../data/tenantsData');
  const currentTenant = getCurrentTenant();
  return tenants[currentTenant] || tenants.empresa1;
};